var _g, _g2, _g3, _g4, _g5, _g6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarsBgSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 520,
    height: 90,
    viewBox: "0 0 520 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M123.15 22.8088L121.325 44.447C120.872 49.8182 116.611 54.0795 111.239 54.5325L89.6011 56.3575L111.239 58.1825C116.611 58.6355 120.872 62.8968 121.325 68.2681L123.15 89.9062L124.975 68.268C125.428 62.8968 129.689 58.6355 135.06 58.1825L156.698 56.3575L135.06 54.5325C129.689 54.0795 125.428 49.8182 124.975 44.447L123.15 22.8088Z",
    fill: "url(#paint0_linear_38_104)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M123.151 89.1093L124.976 67.4711C125.429 62.0998 129.69 57.8386 135.061 57.3856L156.7 55.5606L132.404 56.2728L-nan -nanL-nan -nanL132.404 56.2728C127.77 56.4602 124.061 60.1806 123.888 64.8143L123.863 65.4777L123.151 89.1093Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.2007 0.996582L69.2007 23.871",
    stroke: "white",
    strokeWidth: 0.609983,
    strokeDasharray: "1.22 1.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6367 12.4342L57.7623 12.4342",
    stroke: "white",
    strokeWidth: 0.609983,
    strokeDasharray: "1.22 1.83"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.3988 31.9569L23.0715 47.6939C22.742 51.6004 19.6429 54.6995 15.7364 55.0289L-0.000567582 56.3562L15.7365 57.6835C19.6429 58.013 22.742 61.1121 23.0715 65.0186L24.3988 80.7556L25.7261 65.0186C26.0555 61.1121 29.1547 58.013 33.0611 57.6835L48.7981 56.3562L33.0611 55.0289C29.1547 54.6995 26.0555 51.6003 25.7261 47.6939L24.3988 31.9569Z",
    fill: "url(#paint1_linear_38_104)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.4001 80.7556L25.7274 65.0186C26.0569 61.1122 29.156 58.013 33.0625 57.6836L48.7995 56.3563L31.1295 56.8742L-nan -nanL-nan -nanL31.1295 56.8742C27.7599 57.0106 25.0623 59.7163 24.9362 63.0864L24.9181 63.5688L24.4001 80.7556Z",
    fill: "#C4C4C4"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M396.547 22.8088L398.372 44.447C398.825 49.8182 403.087 54.0795 408.458 54.5325L430.096 56.3575L408.458 58.1825C403.087 58.6355 398.825 62.8968 398.372 68.2681L396.547 89.9062L394.722 68.268C394.269 62.8968 390.008 58.6355 384.637 58.1825L362.999 56.3575L384.637 54.5325C390.008 54.0795 394.269 49.8182 394.722 44.447L396.547 22.8088Z",
    fill: "url(#paint2_linear_38_104)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M396.546 89.1093L394.721 67.4711C394.268 62.0998 390.007 57.8386 384.636 57.3856L362.998 55.5606L387.294 56.2728L-nan -nanL-nan -nanL387.294 56.2728C391.927 56.4602 395.636 60.1806 395.809 64.8143L395.834 65.4777L396.546 89.1093Z",
    fill: "#C4C4C4"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.497 0.996582L450.497 23.871",
    stroke: "white",
    strokeWidth: 0.609983,
    strokeDasharray: "1.22 1.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.061 12.4342L461.935 12.4342",
    stroke: "white",
    strokeWidth: 0.609983,
    strokeDasharray: "1.22 1.83"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M495.299 31.9569L496.626 47.6939C496.955 51.6004 500.054 54.6995 503.961 55.0289L519.698 56.3562L503.961 57.6835C500.054 58.013 496.955 61.1121 496.626 65.0186L495.299 80.7556L493.971 65.0186C493.642 61.1121 490.543 58.013 486.636 57.6835L470.899 56.3562L486.636 55.0289C490.543 54.6995 493.642 51.6003 493.971 47.6939L495.299 31.9569Z",
    fill: "url(#paint3_linear_38_104)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M495.297 80.7556L493.97 65.0186C493.64 61.1122 490.541 58.013 486.635 57.6836L470.898 56.3563L488.568 56.8742L-nan -nanL-nan -nanL488.568 56.8742C491.937 57.0106 494.635 59.7163 494.761 63.0864L494.779 63.5688L495.297 80.7556Z",
    fill: "#C4C4C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_38_104",
    x1: 145.821,
    y1: 35.5203,
    x2: 99.1135,
    y2: 94.1717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121317"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_38_104",
    x1: 40.8873,
    y1: 41.2017,
    x2: 6.9176,
    y2: 83.8578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121317"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_38_104",
    x1: 373.876,
    y1: 35.5203,
    x2: 420.584,
    y2: 94.1717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121317"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_38_104",
    x1: 478.81,
    y1: 41.2017,
    x2: 512.78,
    y2: 83.8578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121317"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsBgSm);
export default __webpack_public_path__ + "static/media/stars-bg-sm.ab6c54e12e4b2797a2dd9b31265d7359.svg";
export { ForwardRef as ReactComponent };